<template>
  <div class="row">
    <div class="col-md-6 col-12" v-for="(book, index) in books">
      <b-card no-body class="overflow-hidden">
        <b-row no-gutters align-v="center">
          <b-col cols="2">
            <b-card-img
              :src="book.front_cover.url"
              :alt="getBookNameAndCode(book)"
              width="50px"
              height="70px"
              left
              @click="showCover(book)"
            ></b-card-img>
          </b-col>
          <b-col cols="10">
            <b-card-body>
              <b-card-text>
                <h5>{{ getBookNameAndCode(book) }}</h5>
                <p>{{ getBookAuthor(book) }}</p>
              </b-card-text>
              <b-button-toolbar>
                <b-button-group>
                  <b-button block variant="outline-default" @click="showInfo(book)">{{ $t('book.button.introduction.label') }}</b-button>
                </b-button-group>
                <b-button-group>
                  <b-button
                    variant="primary"
                    @click="addBookToApplicationList(book)"
                    :disabled="book.in_stock === 'N'"
                    v-if="applicable"
                  >{{ book.in_stock === 'N' ? $t('book.button.application.label.out-of-stock') : $t('book.button.application.label.in-stock') }}</b-button>
                  <b-button
                    variant="info"
                    @click="showDownloadList(book)"
                    v-if="downloadable"
                  >{{ $t('book.button.download.label') }}</b-button>
                </b-button-group>
              </b-button-toolbar>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <dharma-application-form ref="application_form" v-if="applicable"></dharma-application-form>
    <image-modal :id="`book-cover-modal-${uuid}`" :image="book_cover"></image-modal>
    <b-modal :id="`book-info-${uuid}`" :title="$t('book.detail.title')" scrollable centered>
      <book-info :book="book"></book-info>
      <b-button-toolbar>
        <b-button-group>
          <b-button
            variant="outline-default"
            @click="showSizeCmConversionTable()"
          >{{ $t('book.button.size-cm-conversion.label') }}</b-button>
        </b-button-group>
        <b-button-group>
          <b-button
            variant="primary"
            @click="addBookToApplicationList(book)"
            :disabled="book && book.in_stock === 'N'"
            v-if="applicable"
          >{{ book && book.in_stock === 'N' ? $t('book.button.application.label.out-of-stock') : $t('book.button.application.label.in-stock') }}</b-button>
          <b-button
            variant="info"
            @click="showDownloadList(book)"
            v-if="downloadable"
          >{{ $t('book.button.download.label') }}</b-button>
        </b-button-group>
      </b-button-toolbar>
      <template #modal-footer="{ close }">
        <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
      </template>
    </b-modal>
    <efile-list-modal :id="`book-efile-list-modal-${uuid}`" :title="$t('book.efile-list.title')" v-if="downloadable">
      <template #efile-list>
        <book-efile-list :efiles="book_efiles" ></book-efile-list>
      </template>
    </efile-list-modal>
    <size-cm-conversion-table-modal :id="`size-cm-conversion-table-modal-${uuid}`"></size-cm-conversion-table-modal>
    <dharma-grant-susp-msg-modal id="dharma-grant-susp-msg-modal"></dharma-grant-susp-msg-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import UUID from '@estudioliver/vue-uuid-v4'

import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { CardPlugin } from 'bootstrap-vue'
import { ImagePlugin } from 'bootstrap-vue'
import { LayoutPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'

import ApplicationList from '@/components/forms/dharma-application-form/ApplicationList'
import DharmaApplicationForm from '@/components/forms/dharma-application-form/DharmaApplicationForm'
import BookInfo from '@/components/info/BookInfo'
import BookEfileList from '@/components/lists/BookEfileList'
import EfileListModal from '@/components/modals/EfileListModal.vue'
import ImageModal from '@/components/modals/ImageModal'
import SizeCmConversionTableModal from '@/components/modals/SizeCmConversionTableModal'
import DharmaGrantSuspMsgModal from '@/components/modals/DharmaGrantSuspMsgModal'

import i18n from '@/plugins/i18n.js'

import BookApiService from '@/services/budaedu-api-services/book-api-service.js'

Vue.use(ButtonGroupPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(ButtonPlugin)
Vue.use(CardPlugin)
Vue.use(ImagePlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(UUID)

Vue.use(ApplicationList)

Vue.use(BookApiService)

export default {
  i18n,
  name: 'book-card-list',
  props: {
    books: {
      type: Array,
      required: true
    },
    applicable: {
      type: Boolean,
      default: true
    },
    downloadable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      uuid: null,
      book: null,
      book_cover: null,
      book_efiles: []
    }
  },
  methods: {
    addBookToApplicationList(book) {
      this.$dharmaApplicationList.addItem({
        code: book.code,
        name: book.chinese_name,
        quantity: book.quantity,
        advanced: book.advanced,
        apply_type: 'book'
      })
      
      this.$bvModal.show(`application-success-message-${this.$refs[`application_form`].uuid}`)

      // this.showDharmaGrantSuspensionMessage()
    },
    showDharmaGrantSuspensionMessage() {
      this.$bvModal.show('dharma-grant-susp-msg-modal')
    },
    async showCover(book) {
      this.book_cover = await this.$bookApiService.getCover(book)
      this.$bvModal.show(`book-cover-modal-${this.uuid}`)
    },
    showInfo(book) {
      this.book = book
      this.$bvModal.show(`book-info-${this.uuid}`)
    },
    async showDownloadList(book) {
      this.book_efiles = await this.$bookApiService.getEfiles(book)
      this.$bvModal.show(`book-efile-list-modal-${this.uuid}`)
    },
    showSizeCmConversionTable() {
      this.$bvModal.show(`size-cm-conversion-table-modal-${this.uuid}`)
    },
    getBookName(book) {
      const name = this.$i18n.locale === 'tw' || !book.english_name
        ? book.chinese_name
        : book.english_name
      return `${name} ${book.original_name}`.trim()
    },
    getBookNameAndCode(book) {
      return `${this.getBookName(book)} ${book.code}`
    },
    getBookAuthor(book) {
      const author = this.$i18n.locale === 'tw' || !book.english_author
        ? book.chinese_author
        : book.english_author
      return `${author} ${book.original_author}`.trim()
    },
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    this.uuid = this.$uuidKey()
  },
  components: {
    BookEfileList,
    BookInfo,
    DharmaApplicationForm,
    DharmaGrantSuspMsgModal,
    EfileListModal,
    ImageModal,
    SizeCmConversionTableModal
  }  
}
</script>